import React, { useEffect } from "react";
import './Zero.css';
import { Container} from '@mui/material';

export default function ErrorPage() {
  useEffect(()=>{
    document.title="Error Page";
  },[]);
  // const error = useRouteError();
  // console.error(error);

  return (
    <div className = "App">
    <div className = "backgroundImage "></div>
    <div id="error-page">
    <Container maxWidth="lg" sx={{ pt: 2 }}>
      <h1>系统更新，请检查您输入的地址</h1>
      <p>最新的正确格式为：https://17talk.xyz/chat/english/chinese/a0451x/StudentID “chat/”的后面，是要学习的语言和自己的母语，再后面是每周更新的会话编号。请向班主任领取此编号。</p>
      </Container>
    </div>
    </div>
   
    
  );
}